import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { Button } from "antd";
import genista from "../../../assets/images/genista.png";
import { signIn, guestSignIn } from "../../../actions/signIn";
import "./LogIn.css";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      passType: "password",
      loading: false,
    };
  }

  componentDidMount() {
    if (window.location.search.includes("unauthorized")) {
      toast.error("Authentication credentials were not provided.");
    }
  }

  onKeyDownLogin = (event, tab) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onSubmitLoginData(event, tab);
    }
  };

  apiSignIn = async (email, password) => {
    const params = {
      email,
      password,
    };
    const loginResponse = await signIn(params);
    return loginResponse;
  };

  onSubmitLoginData = async () => {
    const { email, password } = this.state;

    if (!email || !password) {
      toast.error("Please enter Email and Password");
      return;
    }

    const lowercaseEmail = email.toLowerCase();
    this.setState({ loading: true }, () => {
      this.apiSignIn(lowercaseEmail, password).then((response) => {
        if (!response.success) {
          toast.error(response.message);
          this.setState({ loading: false });
          return;
        }
        delete response.permissions; // no need to store the permissions list
        sessionStorage.setItem(
          "user_details_automation",
          JSON.stringify(response),
        );
        window.location.assign("/");
      });
    });
  }

  handleGuestLogin = () => {
    const response = guestSignIn();
    sessionStorage.setItem(
      "user_details_automation",
      JSON.stringify(response),
    );
    window.location.assign("/micro");
  }

  showHidePassword = () => {
    this.setState(({ passType }) => ({
      passType: passType === "text" ? "password" : "text",
    }));
  };

  onChangeLogin = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { loginTab } = this.props;
    const {
      email,
      password,
      passType,
      loading,
    } = this.state;
    return (
      <div className="Login">
        <div className="Login__Header">
          {" "}
          <img className="Login__Logo" src={genista} alt="genista_logo" />
          {" "}
          Automation
        </div>
        <div className="Login__Body">
          <div>
            <div className="login-box">
              <div className="login-logo">
                <img src={genista} alt="genista_logo" />
              </div>
              <Form>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email || ""}
                    onKeyDown={(event) => this.onKeyDownLogin(event, loginTab)}
                    onChange={(event) => this.onChangeLogin(event)}
                    autoComplete="on"
                  />
                </Form.Group>
                <Form.Group className="Login__Form__Pwd">
                  <Form.Label>Password</Form.Label>
                  <div className="Login__Form__Pwd__Input">
                    <Form.Control
                      type={passType}
                      name="password"
                      value={password || ""}
                      onKeyDown={(event) => this.onKeyDownLogin(event, loginTab)}
                      onChange={(event) => this.onChangeLogin(event)}
                      autoComplete="on"
                    />
                    <FontAwesomeIcon
                      onClick={this.showHidePassword}
                      icon={passType === "text" ? faEyeSlash : faEye}
                      className="Login__Form__Pwd__Icon"
                    />
                  </div>
                </Form.Group>
              </Form>
            </div>
            <div className="login-btn-box">
              <div className="mt-3">
                <Button
                  onClick={(event) => this.onSubmitLoginData(event)}
                  className="login-btn"
                  loading={loading}
                  type="primary"
                >
                  Sign In
                </Button>
              </div>
              {/* <div className="Login__Guest__Login">
                <p className="Login__Guest__Text">Don&apos;t have an account yet?</p>
                <div>
                  <button
                    type="button"
                    onClick={() => this.handleGuestLogin()}
                    className="login-btn Login__Guest__LoginBtn"
                  >
                    Continue as a guest
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
